import { createReducer, on } from '@ngrx/store';
import { initialState } from './kill-switch.state';
import { KillSwitchActions } from './kill-switch.actions';

export const killSwitchReducer = createReducer(
  initialState,

  on(KillSwitchActions.public.loadKillSwitch, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(
    KillSwitchActions.private.loadKillSwitchSuccess,
    (state, { responseDto }) => {
      return {
        ...state,
        state: responseDto.state,
        isLoading: false,
        error: null,
      };
    },
  ),

  on(KillSwitchActions.private.loadKillSwitchFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(KillSwitchActions.public.triggerKillSwitch, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(
    KillSwitchActions.private.triggerKillSwitchSuccess,
    (state, { responseDto }) => {
      return {
        ...state,
        state: responseDto.state,
        isLoading: false,
        error: null,
      };
    },
  ),

  on(
    KillSwitchActions.private.triggerKillSwitchFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error: error,
    }),
  ),

  on(KillSwitchActions.public.refreshKillSwitchDataFromWebSocket, (state) => ({
    ...state,
  })),

  on(KillSwitchActions.public.loadEmergencyStop, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(
    KillSwitchActions.private.loadEmergencyStopSuccess,
    (state, { responseDto }) => ({
      ...state,
      isLoading: false,
      error: null,
      emergencyStop: {
        isConfigured: responseDto.isConfigured,
        isActive: responseDto.isActive,
        triggeredAt: responseDto.triggeredAt,
      },
    }),
  ),

  on(
    KillSwitchActions.private.loadEmergencyStopFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error: error,
    }),
  ),

  on(KillSwitchActions.public.triggerEmergencyStop, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(
    KillSwitchActions.private.triggerEmergencyStopSuccess,
    (state, { responseDto }) => ({
      ...state,
      // triggering the emergency stop always turns the kill switch on as well
      state: true,
      isLoading: false,
      error: null,
      emergencyStop: {
        isConfigured: responseDto.isConfigured,
        isActive: responseDto.isActive,
        triggeredAt: responseDto.triggeredAt,
      },
    }),
  ),

  on(
    KillSwitchActions.private.triggerEmergencyStopFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error: error,
    }),
  ),
);
